import React from 'react';
import RiskDonut, { RiskDonutPropDef } from 'components/charts/RiskDonut/RiskDonut';

const RiskDonutGrid: React.SFC<RiskDonutGridPropDef> = ({
  items,
  disableTransition,
}) => (
  <ul className="l-risk-grid">
    {items.map(item => (
      <li key={item.label}>
        <RiskDonut {...item} disableTransition={disableTransition} />
      </li>
    ))}
  </ul>
);

export interface RiskDonutGridPropDef {
  items: RiskDonutPropDef[];
  disableTransition?: boolean;
}

export default RiskDonutGrid;
